import { ContactWindow } from "@/components/contacts/ContactWindow";
import { contactsFilterCategory } from "@/data/filters/categories/contacts";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute(
  "/_dashboard/campaigns/setup/define/advanced/$quality/$category/contacts",
)({
  component: RouteComponent,
  loader: ({ context }) => {
    const title = [context.configuration.name, contactsFilterCategory.title]
      .filter(Boolean)
      .join(" - ");

    return {
      crumb: title,
      meta: {
        title,
      },
    };
  },
});

function RouteComponent() {
  const { useAdvancedConfiguration } = Route.useRouteContext();
  const navigate = Route.useNavigate();

  const [configuration, setConfiguration] = useAdvancedConfiguration();
  return (
    <div>
      <ContactWindow
        configuration={configuration}
        onDoneUpdating={() =>
          navigate({ to: "/campaigns/setup/define/advanced" })
        }
        setConfiguration={setConfiguration}
      />
    </div>
  );
}
